import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Field } from "@/components/common";
import { api, errMsg, fmtQty, MOVE_LABELS } from "@/lib/api";
import { toast } from "sonner";
import { findByCode } from "@/lib/barcode";

export function MovementDialog({ item, suppliers, onClose, onDone }) {
  const [f, setF] = useState({ type: item.type || "entrada", qty: item.scan ? "1" : "", unit_cost: item.cost || "", supplier_id: "", reason: "" });
  const [code, setCode] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const onScan = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    const c = code.trim();
    setCode("");
    if (!c) return;
    if (findByCode([item], c)) setF((x) => ({ ...x, qty: String((Number(x.qty) || 0) + 1) }));
    else toast.error("Este código é de outro produto. Registre este primeiro.");
  };
  const submit = async () => {
    try {
      await api.post("/stock/movements", { kind: item.kind, item_id: item.id, type: f.type, qty: Number(f.qty) || 0, reason: f.reason,
        unit_cost: f.type === "entrada" && f.unit_cost !== "" ? Number(f.unit_cost) : null, supplier_id: f.type === "entrada" ? f.supplier_id || null : null });
      toast.success("Movimentação registrada");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="stock-movement-modal">
        <DialogHeader><DialogTitle>{item.name}</DialogTitle><DialogDescription>Saldo atual: {fmtQty(item.stock)} {item.unit}</DialogDescription></DialogHeader>
        <div className="grid grid-cols-4 gap-2">
          {["entrada", "saida", "ajuste", "perda"].map((t) => (
            <Button key={t} variant={f.type === t ? "default" : "outline"} size="sm" onClick={() => setF((x) => ({ ...x, type: t }))} data-testid={`movement-type-${t}`}>{MOVE_LABELS[t].replace(" manual", "")}</Button>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3">
          {item.scan && (
            <Field label="Leitor de código de barras" hint="Cada leitura deste produto soma +1. Ou digite o total em Quantidade." className="col-span-2">
              <Input value={code} onChange={(e) => setCode(e.target.value)} onKeyDown={onScan} autoFocus inputMode="numeric" placeholder="Passe o leitor aqui" data-testid="movement-scan-input" />
            </Field>
          )}
          <Field label={f.type === "ajuste" ? `Novo saldo (${item.unit})` : `Quantidade (${item.unit})`}><Input type="number" step="0.001" min="0" value={f.qty} onChange={set("qty")} data-testid="movement-qty-input" /></Field>
          {f.type === "entrada" && <Field label="Custo unitário (R$)"><Input type="number" step="0.01" value={f.unit_cost} onChange={set("unit_cost")} data-testid="movement-cost-input" /></Field>}
          {f.type === "entrada" && (
            <Field label="Fornecedor" className="col-span-2">
              <select value={f.supplier_id} onChange={set("supplier_id")} className="h-10 rounded-md border bg-transparent px-2 text-sm" data-testid="movement-supplier-select">
                <option value="">Sem fornecedor</option>{suppliers.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </Field>
          )}
          <Field label={f.type === "perda" ? "Motivo da perda" : "Observação"} className="col-span-2"><Input value={f.reason} onChange={set("reason")} placeholder={f.type === "perda" ? "Ex.: vencido, quebrado" : ""} data-testid="movement-reason-input" /></Field>
        </div>
        <DialogFooter><Button onClick={submit} disabled={f.qty === ""} data-testid="movement-confirm-btn">Registrar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
